import React from 'react'
import Pg6 from '../../../myapp/services/add-money/Pg/Pg6'

function PG6Page() {
  return (
    <Pg6/>
  )
}

export default PG6Page